import { render } from "./Messages.vue?vue&type=template&id=76e3d448"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
script.render = render

export default script